import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EfCardsB from '@elem/ui/ef-cards-b';
import EfIcon from '@elem/ui/ef-icon';
import EfSection from '@elem/ui/ef-section';
import EfShopCardA from '@elem/ui/ef-shop-card-a';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import EmailCom from '../../common/EmailCom';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const { locale = 'us' } = useRouter();
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724126585002/sectionC_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139236119/sectionC_card_1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724126559518/sectionC_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139236749/sectionC_card_2_h5.jpg',
            desc: t('section_C_card2_title'),
            title: t('section_C_card2_desc'),
            vertical: 'descTop',
            position: 'left50',
            fixedElement: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724664014770/qi2_icon.png" />,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724835895952/sectionC_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724835895953/sectionC_card_3_h5.jpg',

            desc: t('section_C_card3_desc'),
            title: t('section_C_card3_title'),
            position: 'left50',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724835895953/sectionC_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724835895950/sectionC_card_4_h5.jpg',

            desc: t('section_C_card4_title'),
            title: t('section_C_card4_desc'),
            title2: t('section_C_card4_desc2'),
            vertical: 'descTop',
            position: 'left50',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724126558920/sectionC_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139236342/sectionC_card_5_h5.jpg',

            title: t('section_C_card5_title'),
            desc: t('section_C_card5_desc'),
            position: 'left50',
        },
    ];
    const itemB1 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668293365/sectionC_product_1_1.png',
        label: t('section_C_product1_label'),
        title: t('section_C_product1_title'),
        desc: t('section_C_product1_desc'),
        desc2: t('section_C_product1_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),
        circleItems: [
            {
                type: 'b1',
                toolTipText: 'Sliver',
            },
            {
                type: 'b2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'b3',
                toolTipText: 'Black',
            },
        ],
    };
    const itemB2 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668293512/sectionC_product_1_2.png',
        label: t('section_C_product1_label'),
        title: t('section_C_product1_title'),
        desc: t('section_C_product1_desc'),
        desc2: t('section_C_product1_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),
        circleItems: [
            {
                type: 'b1',
                toolTipText: 'Sliver',
            },
            {
                type: 'b2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'b3',
                toolTipText: 'Black',
            },
        ],
    };
    const itemB3 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668294284/sectionC_product_1_3.png',
        label: t('section_C_product1_label'),
        title: t('section_C_product1_title'),
        desc: t('section_C_product1_desc'),
        desc2: t('section_C_product1_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),
        circleItems: [
            {
                type: 'b1',
                toolTipText: 'Sliver',
            },
            {
                type: 'b2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'b3',
                toolTipText: 'Black',
            },
        ],
    };
    const itemC1 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668293708/sectionC_product_2_1.png',
        label: t('section_C_product2_label'),
        title: t('section_C_product2_title'),
        desc: t('section_C_product2_desc'),
        desc2: t('section_C_product2_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),

        circleItems: [
            {
                type: 'c1',
                toolTipText: 'Sliver',
            },
            {
                type: 'c2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'c3',
                toolTipText: 'Black',
            },
        ],
    };
    const itemC2 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668293897/sectionC_product_2_2.png',
        label: t('section_C_product2_label'),
        title: t('section_C_product2_title'),
        desc: t('section_C_product2_desc'),
        desc2: t('section_C_product2_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),

        circleItems: [
            {
                type: 'c1',
                toolTipText: 'Sliver',
            },
            {
                type: 'c2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'c3',
                toolTipText: 'Black',
            },
        ],
    };
    const itemC3 = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724668294080/sectionC_product_2_3.png',
        label: t('section_C_product2_label'),
        title: t('section_C_product2_title'),
        desc: t('section_C_product2_desc'),
        desc2: t('section_C_product2_desc2'),
        moreLink: `https://www.ecoflow.com/${locale}/rapid-magnetic-power-bank`,
        moreText: t('section_product_btn_text'),

        circleItems: [
            {
                type: 'c1',
                toolTipText: 'Sliver',
            },
            {
                type: 'c2',
                toolTipText: 'Light Blue',
            },
            {
                type: 'c3',
                toolTipText: 'Black',
            },
        ],
    };
    const [itemB, setItemB] = useState(itemB1);
    const [itemC, setItemC] = useState(itemC1);
    // 切换卡片B
    const itemBCallback = (item: any) => {
        if (item.type === 'b1') {
            setItemB(itemB1);
        } else if (item.type === 'b2') {
            setItemB(itemB2);
        } else if (item.type === 'b3') {
            setItemB(itemB3);
        }
    };
    // 切换卡片C
    const itemCCallback = (item: any) => {
        if (item.type === 'c1') {
            setItemC(itemC1);
        } else if (item.type === 'c2') {
            setItemC(itemC2);
        } else if (item.type === 'c3') {
            setItemC(itemC3);
        }
    };

    const OffTips = () => {
        return (
            <span className="SectionA-off-tips">
                {t('section_C_off_value')} <span className="SectionA-off-tips-text">{t('section_off')}</span>
            </span>
        );
    };
    return (
        <div className={styles.TheComp} id="ID-SectionC">
            <EfSpec />
            <EfSection title={t('section_C_title')} desc={t('section_C_desc')} />
            <EfCardsB items={itemsA} />
            <EmailCom
                offTipsL={t('section_early_bird_title2')}
                offTips={<OffTips />}
                offTipsR={t('section_and')}
                freeTips={t('section_free')}
                freeTipsR={t('section_bag_3')}
                productValue={[3]}
                gtm_event_name="rapid_submit"
                subscribeData={{
                    sector_name: t('section_C_title'),
                    entry_position: 6,
                }}
            />
            <div className="ef-container SectionC-list">
                <EfShopCardA key={1} {...itemB} position="imgL" callback={itemBCallback} />
                <EfShopCardA key={2} {...itemC} position="imgL" callback={itemCCallback} />
            </div>
        </div>
    );
}
